var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('role-card',{attrs:{"creating":_vm.isCreating,"id":_vm.id}})}
var staticRenderFns = []

export { render, staticRenderFns }